import request from '@/utils/request'

// 查询银河打本店家开本列表
export function listScriptShopOpen(query) {
  return request({
    url: '/played/script/shop/open/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本店家开本详细
export function getScriptShopOpen(id) {
  return request({
    url: '/played/script/shop/open/' + id,
    method: 'get'
  })
}

// 新增银河打本店家开本
export function addScriptShopOpen(data) {
  return request({
    url: '/played/script/shop/open',
    method: 'post',
    data: data
  })
}

// 修改银河打本店家开本
export function updateScriptShopOpen(data) {
  return request({
    url: '/played/script/shop/open',
    method: 'put',
    data: data
  })
}

// 删除银河打本店家开本
export function delScriptShopOpen(id) {
  return request({
    url: '/played/script/shop/open/' + id,
    method: 'delete'
  })
}

// 分页查询银河打本店家开本房间信息
export function queryOpenScriptInfoPage(query) {
  return request({
    url: '/played/script/shop/open/query/page',
    method: 'get',
    params: query
  })
}

// 分页查询银河打本店家开本(进化论)
export function pageJhlOpenScript(query) {
  return request({
    url: '/played/script/shop/open/jhl/page',
    method: 'get',
    params: query
  })
}

// 查询银河打本各维度开本数据汇总看板
export function queryOpenStatisticsList(query) {
  return request({
    url: '/played/script/shop/open/open/statistics/list',
    method: 'get',
    params: query
  })
}

// 新增银河打本店家开本(进化论)
export function addJhl(data) {
  return request({
    url: '/played/script/shop/open/jhl/add',
    method: 'post',
    data: data
  })
}

// 删除银河打本店家开本(进化论)
export function removeJhl(id) {
  return request({
    url: '/played/script/shop/open/jhl/' + id,
    method: 'delete'
  })
}
